import React, { Component } from 'react';
import LoadingSpinner from "../Utils/LoadingSpinner";

class CreateAccountForm extends Component {
    state = {
        loading: false,
        result: null,
        account_token:null,
        bank_account_token: null,
        fields: {
            businessName: "Acme",
            company_street_address1: "624  Midway Road",
            company_city: "Fort Smith",
            company_state: "AR",
            company_zip: "72901",
            routing_number: "110000000",
            account_number: "000123456789",
        }
    };

    onInputChange = evt => {
        const fields = Object.assign({}, this.state.fields);
        fields[evt.target.name] = evt.target.value;
        this.setState({acct: fields});
    };

    /*
    * This method sends the external bank information collected in the form in this component to Stripe.
    * Stripe in turn returns us the hash of this information in form of one time token
    */
    requestExternalAccountToken = () => {
        const bankAccount = {
            country: 'US',
                currency: 'usd',
                routing_number: this.state.fields.routing_number,
                account_number: this.state.fields.account_number,
        };

        this.props.stripe.createToken('bank_account', bankAccount).then( (result) => {
            // We got the external account token, now let's
            // get the stripe account token
            this.requestStripeAccountToken(result.token.id);
        });
    };


    /*
    * This method sends the company information collected in the form in this component to Stripe.
    * Stripe in turn returns us the hash of this information in form of one time token
    */
    requestStripeAccountToken = (external_account_token) => {

        const companyInfo = {
            business_type: 'company',
            company: {
                name: this.state.fields.businessName,
                address: {
                    line1: this.state.fields.company_street_address1,
                    city: this.state.fields.company_city,
                    state: this.state.fields.company_state,
                    postal_code: this.state.fields.company_zip,
                },
            },
            tos_shown_and_accepted: true,
        };

        console.log('Requesting account token from STRIPE ...');
        this.props.stripe.createToken('account', companyInfo).then( (result) => {
            console.log('got company token');
            this.requestStripeAccountCreation(external_account_token, result.token.id);
        });

    };

    /*
    * This method sends the hash of external bank account and hash of stripe account to simGPS
    * to finalize the Stripe account creation
     */
    requestStripeAccountCreation = (external_account_token, stripe_account_token) => {

        console.log("Asking SimGPS to create partner account  ...");
        this.props.simGps.createStripePartnerAccount(external_account_token, stripe_account_token,
            (success, result) => {
                this.setState({loading: false, complete:success, result: result});
            });
    };

    createStripeAccount = evt => {
        evt.preventDefault();

        this.setState({loading:true}, () => {
            // Start chain of the requests
            this.requestExternalAccountToken();
            }
        );
    };

    render() {
        if ( this.state.loading ){
            return <LoadingSpinner text="Creating account ..."/>;
        }

        return (
            <div>
                Please specify your business information
                <form  onSubmit={this.createStripeAccount}>
                    <label>
                        <span>Business Name</span>
                        <input name="businessName" value={this.state.fields.businessName} onChange={this.onInputChange} />
                    </label>
                    <fieldset>
                        <legend>Business Address</legend>
                        <label>
                            <span>Street Address Line 1</span>
                            <input name="company_street_address1" value={this.state.fields.company_street_address1} onChange={this.onInputChange} />
                        </label>
                        <label>
                            <span>City</span>
                            <input name="company_city" value={this.state.fields.company_city} onChange={this.onInputChange} />
                        </label>
                        <label>
                            <span>State</span>
                            <input name="company_state" value={this.state.fields.company_state} onChange={this.onInputChange} />
                        </label>
                        <label>
                            <span>Postal Code</span>
                            <input name="company_zip" value={this.state.fields.company_zip} onChange={this.onInputChange} />
                        </label>
                    </fieldset>
                    <fieldset>
                        <span>Routing Number</span>
                        <input name="routing_number" value={this.state.fields.routing_number} onChange={this.onInputChange} />
                        <span>Account Number</span>
                        <input name="account_number" value={this.state.fields.account_number} onChange={this.onInputChange} />
                    </fieldset>
                    <button>Create Partner Account</button>
                </form>


                <p>By clicking, you agree to <a href="/">our terms</a> and the <a href="/">Stripe Connected Account Agreement</a>.</p>

            </div>
        );
    }
}

export default CreateAccountForm;
